import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'home',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/Mine.vue')
    },
    {
        path: '/inform',
        name: 'inform',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/dynamic/inform.vue')
    },
    {
        path: '/notice',
        name: 'notice',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/dynamic/notice.vue')
    },
    {
        path: '/news',
        name: 'news',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/dynamic/news.vue')
    },
    {
        path: '/industry',
        name: 'industry',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/dynamic/industry.vue')
    },
    {
        path: '/introduction',
        name: 'introduction',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/association/introduction.vue')
    },
    {
        path: '/introductionmove',
        name: 'introductionmove',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/association/introductionmove.vue')
    },
    {
        path: '/introductionmutual',
        name: 'introductionmutual',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/association/introductionmutual.vue')
    },
    {
        path: '/introductionniandu',
        name: 'introductionniandu',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/association/introductionniandu.vue')
    },
    {
        path: '/partyBranch',
        name: 'partyBranch',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/association/partyBranch.vue')
    },
    {
        path: '/contactUs',
        name: 'contactUs',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/contact/contactUs.vue')
    },
    {
        path: '/organizational',
        name: 'organizational',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/association/organizational.vue')
    },
    {
        path: '/rules',
        name: 'rules',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/association/rules.vue')
    },
    {
        path: '/search',
        name: 'search',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/search.vue')
    },
    {
        path: '/detail',
        name: 'detail',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/components/details.vue'),
        hidden: true,
        // query: { id: this.id, type: this.type }
    },
    {
        path: '/membership',
        name: 'membership',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/application/membership.vue'),
        hidden: true,
    },
    {
        path: '/guide',
        name: 'guide',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/application/guide.vue'),
        hidden: true,
    },
    {
        path: '/standard',
        name: 'standard',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/application/standard.vue'),
        hidden: true,
    },
    {
        path: '/mieninform',
        name: 'mieninform',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/activity/mieninform.vue'),
        hidden: true,
    },
    {
        path: '/mien',
        name: 'mien',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/activity/mien.vue'),
        hidden: true,
    },
    {
        path: '/miens',
        name: 'miens',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/activity/miens.vue'),
        hidden: true,
    },
    {
        path: '/district',
        name: 'district',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/policy/district.vue'),
        hidden: true,
    },
    {
        path: '/nation',
        name: 'nation',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/policy/nation.vue'),
        hidden: true,
    },
    {
        path: '/policymove',
        name: 'policymove',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/policy/move.vue'),
        hidden: true,
    },
    {
        path: '/policymutual',
        name: 'policymutual',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/policy/mutual.vue'),
        hidden: true,
    },
    {
        path: '/other',
        name: 'other',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/policy/other.vue'),
        hidden: true,
    },
    {
        path: '/notify',
        name: 'notify',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/serve/notify.vue'),
        hidden: true,
    },
    {
        path: '/preview',
        name: 'preview',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/serve/preview.vue'),
        hidden: true,
    },
    {
        path: '/review',
        name: 'review',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/serve/review.vue'),
        hidden: true,
    },
    {
        path: '/teachers',
        name: 'teachers',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/serve/teachers.vue'),
        hidden: true,
    },
    {
        path: '/textbook',
        name: 'textbook',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/serve/textbook.vue'),
        hidden: true,
    },
    {
        path: '/exhibit',
        name: 'exhibit',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/vipStyle/exhibit.vue'),
        hidden: true,
    },
    {
        path: '/move',
        name: 'move',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/vipStyle/move.vue'),
        hidden: true,
    },
    {
        path: '/moveer',
        name: 'moveer',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/mutuals/moveer.vue'),
        hidden: true,
    },
    {
        path: '/mutual',
        name: 'mutual',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/mutuals/mutual.vue'),
        hidden: true,
    },
    {
        path: '/mutuals',
        name: 'mutuals',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/mutuals/mutuals.vue'),
        hidden: true,
    },
    {
        path: '/niandu',
        name: 'niandu',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/mutuals/niandu.vue'),
        hidden: true,
    },
    {
        path: '/mutual',
        name: 'mutual',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/vipStyle/mutual.vue'),
        hidden: true,
    },
    {
        path: '/exhibitDetail',
        name: 'exhibitDetail',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/update/vipStyle/exhibitDetail.vue'),
        hidden: true,
    },
    {
        path: '/policyDetail',
        name: 'policyDetail',
        component: () =>
            import ('../views/update/policy/components/detail.vue')
    }

]

const router = new VueRouter({
        mode: 'history',
        base: process.env.BASE_URL,
        routes
    })
    // router.beforeEach((to, from, next) => {
    //
    //     // 让页面回到顶部
    //
    //     // chrome
    //
    //     document.body.scrollTop = 0;
    //
    //     // firefox
    //
    //     document.documentElement.scrollTop = 0;
    //
    //     // safari
    //
    //     window.pageYOffset = 0;
    //
    //     // 调用 next()，一定要调用 next 方法，否则钩子就不会被销毁
    //
    //     next()
    //
    // })
    // 防止路由重复点击报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
export default router